<template>
  <div class="view agent-home">
    <h1>{{ $t('agent.label.home') }}</h1>

    <div class="buttons">
      <router-link class="new-booking" :to="{name: 'home'}">Make New Booking</router-link>
      <router-link class="profile" :to="{name: 'agent-profile'}">{{ $t('agent.label.profile') }}</router-link>
      <a class="logout"   @click="onLogOut">{{ $t('agent.label.log-out') }}</a>
    </div>

    <h2>{{ $t('menu.my-bookings') }}</h2>

    <!-- this is from old theme. If it can show more than 50 bookings, doesn't need this info -->
    <div class="my-bookings-info"><i18n path="agent.label.my-bookings-info">{{ model.bookings.length }}</i18n></div>

    <div class="my-bookings-container">
      <table class="my-bookings" cellpadding="0" cellspacing="0">
        <thead>
          <th>{{ $t('general.label.confirmation') }}</th>
          <th>{{ $t('general.label.guest-name') }}</th>
          <th>{{ $tc('general.label.activity', 1) }}</th>
          <th>{{ $t('general.label.activity-date') }}</th>
          <th class="text-right">{{ $tc('general.label.passenger', 2) }}</th>
          <th class="text-right">{{ $t('general.label.rate') }}</th>
          <th class="text-right">{{ $t('general.label.total') }}</th>
          <th class="text-right">{{ $t('general.label.commission') }}</th>
        </thead>

        <tbody>
          <tr v-for="(booking, index) in model.bookings" :key="index">
            <td>{{ booking.bookingId }}</td>
            <td>{{ booking.guestName }}</td>
            <td>{{ booking.activityName }}</td>
            <td>{{ booking.activityDate }}</td>
            <td class="text-right">{{ booking.pax }}</td>
            <td class="text-right" v-if="booking.rate > 0">{{ $formatter.percentage(booking.rate/100, 0) }}</td>
            <td class="text-center" v-else="">-</td>
            <td class="text-right">{{ $formatter.baseCurrency(booking.total) }}</td>
            <td class="text-right">{{ $formatter.baseCurrency(booking.commission) }}</td>
          </tr>
        </tbody>

        <tfoot>
          <tr>
            <td colspan="7" class="text-right">{{ $t('general.label.total') }}</td>
            <td class="text-right">{{ $formatter.baseCurrency(totalCommission) }}</td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</template>

<script>

import Agent from '@/models/Agent';

export default {
  name: 'AgentHome',

  data() {
    return {
      model: Agent.active(),
      breadcrumbLabel: this.$t('agent.label.home')
    }
  },

  computed: {
    totalCommission() {
      return this.model.bookings.reduce((total, booking) => total + booking.commission, 0);
    }
  },

  created() {
  },

  components: {
  },

  methods: {
    onLogOut() {
      Agent.logout().then(() => {
        this.$router.push({ name: 'home' });
      });
    }
  }
}
</script>

<style lang="scss">
.view.agent-home {

  .buttons {
    margin-bottom: 30px;
  }

  .new-booking,
  .profile {
    @include button($colorCTA, #fff);
    margin: 0 10px 10px 0;
  }

  .logout {
    @include button(#fff, $colorCTA);
    border: 1px solid $colorCTA;
  }

  .text-right {
    text-align: right !important;
  }

  .text-center {
    text-align: center !important;
  }

  .my-bookings-info {
    margin-bottom: 5px;
  }

  .my-bookings-container {
    width: 100%;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
  }

  .my-bookings {
    width: 100%;
    line-height: 16px;
    border: 1px solid $colorPaleGray;

    th {
      background-color: $colorBgDarkGray;
      color: #fff;
      text-align: left;
      padding: 10px 10px;
    }

    td {
      border-bottom: 1px solid $colorPaleGray;
      padding: 8px 10px;
      @include breakpoint(medium) {
        padding: 10px 12px;
      }
    }

    tfoot td {
      border-bottom: none;
      background-color: $colorBgGray;
      font-weight: 700;
    }
  }

}
</style>